// Import DataTables - note that we're importing the vanilla JS version
import DataTable from 'datatables.net-dt';

document.addEventListener('DOMContentLoaded', function() {
    // Check if the table exists on the page
    const tableElement = document.getElementById('sds-table');
    if (tableElement) {
        // Initialize DataTable with vanilla JS
        // Note: DataTables requires a call on the native DOM element
        const sdsTable = new DataTable(tableElement, {
            // Use DataTables' processing option for better user feedback
            processing: true,
            // Disable initial automatic data detection/loading
            deferRender: true,
            // Start with an empty table and manually load data
            data: [],
            responsive: true,
            paging: true,
            searching: true,
            ordering: true,
            info: true,
            pageLength: 25,
            lengthChange: false,
            language: {
                search: "_INPUT_",
                searchPlaceholder: "Search...",
                emptyTable: "No SDS documents found",
                info: "Showing _START_ to _END_ of _TOTAL_ documents",
                infoEmpty: "Showing 0 to 0 of 0 documents",
                infoFiltered: "(filtered from _MAX_ total documents)"
            },
            // Explicitly define columns to avoid parameter warnings
            columns: [
                { 
                    title: "Document Name", 
                    data: "name",
                    defaultContent: "Untitled Document" // Provide default content for null/undefined values
                },
                { 
                    title: "Download", 
                    data: "download", 
                    orderable: false,
                    defaultContent: "No link available" // Provide default content for null/undefined values
                }
            ],
            columnDefs: [
                { className: "dt-center", targets: [1] }
            ],
            // Wait for data to be loaded before initializing
            initComplete: function() {
                // Add class to search input using vanilla JS
                const searchInput = document.querySelector('.dataTables_filter input');
                if (searchInput) {
                    searchInput.classList.add('search-input');
                }
                
                // Add custom class to pagination container
                const paginationContainer = document.querySelector('.dataTables_paginate');
                if (paginationContainer) {
                    paginationContainer.classList.add('sds-pagination');
                }
                
                // Add custom class to individual pagination buttons
                const paginationButtons = document.querySelectorAll('.dataTables_paginate .paginate_button');
                paginationButtons.forEach(button => {
                    button.classList.add('sds-page-button');
                });
            }
        });
        
        // Show loading message
        const tableBody = document.querySelector('#sds-table tbody');
        if (tableBody) {
            tableBody.innerHTML = '<tr><td colspan="2">Loading SDS documents...</td></tr>';
        }
        
        // Fetch PDF files from WordPress with the SDS category
        fetchPDFFiles();
        
        async function fetchPDFFiles() {
            if (window.sdsData && window.sdsData.length > 0) {
                populateTable(window.sdsData);
                return;
            }
            try {
                const termId = await getTermId('sds');
                let allData = [];
                const perPage = 100;
                // Fetch first page to get total pages
                const params = new URLSearchParams({
                    mime_type: 'application/pdf',
                    media_category: termId,
                    per_page: perPage,
                    page: 1
                });
                let response = await fetch('/wp-json/wp/v2/media?' + params.toString());
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const firstData = await response.json();
                const totalPages = parseInt(response.headers.get('X-WP-TotalPages')) || 1;
                allData = allData.concat(firstData);
                // Fetch remaining pages
                for (let page = 2; page <= totalPages; page++) {
                    const params = new URLSearchParams({
                        mime_type: 'application/pdf',
                        media_category: termId,
                        per_page: perPage,
                        page: page
                    });
                    response = await fetch('/wp-json/wp/v2/media?' + params.toString());
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    const data = await response.json();
                    allData = allData.concat(data);
                }
                if (allData.length > 0) {
                    populateTable(allData);
                } else {
                    const tableBody = document.querySelector('#sds-table tbody');
                    if (tableBody) {
                        tableBody.innerHTML = '<tr><td colspan="2">No SDS documents found</td></tr>';
                    }
                }
            } catch (error) {
                const tableBody = document.querySelector('#sds-table tbody');
                if (tableBody) {
                    tableBody.innerHTML = '<tr><td colspan="2">Error loading SDS documents</td></tr>';
                }
            }
        }
        
        function getTermId(slug) {
            return fetch('/wp-json/wp/v2/media_category?slug=' + slug)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then(data => {
                    if (data && data.length > 0) {
                        return data[0].id;
                    } else {
                        throw new Error('Term not found');
                    }
                });
        }
        
        function populateTable(files) {
            // Clear existing rows
            sdsTable.clear();
            
            // Create array of data objects that match our column definitions
            const tableData = files.map(function(file) {
                if (!file) return { name: null, download: null }; // Handle null files
                
                // Extract file name without extension for display
                let fileName = '';
                if (file.title && file.title.rendered) {
                    fileName = file.title.rendered;
                    // Remove .pdf extension if present for cleaner display
                    fileName = fileName.replace(/\.pdf$/i, '');
                }
                
                // Create download button, only if source_url exists
                let downloadBtn = '';
                if (file.source_url) {
                    downloadBtn = '<a href="' + file.source_url + '" class="download-btn" target="_blank" download><span class="screen-reader-text">Download</span>Download</a>';
                }
                
                // Return object with keys matching the 'data' properties in our columns definition
                return {
                    name: fileName || null,  // Use null if empty string to trigger defaultContent
                    download: downloadBtn || null  // Use null if empty string to trigger defaultContent
                };
            });
            
            // Add all rows at once
            sdsTable.rows.add(tableData);
            
            // Draw table with new data
            sdsTable.draw();
            
            // If no records found, show a message
            if (files.length === 0) {
                const tableBody = document.querySelector('#sds-table tbody');
                if (tableBody) {
                    tableBody.innerHTML = '<tr><td colspan="2">No SDS documents found</td></tr>';
                }
            }
        }
    }
});
